import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './OperationsTable.styles';
import {
  Operation,
  TransactionTabName,
} from '@/features/Profile/sections/Transactions/Transactions.types';
import { OperationRow } from '@/features/Profile/sections/Transactions/components/OperationRow/OperationRow';

interface OperationsTableProps {
  activeTab: TransactionTabName;
  operations: Operation[];
  onShowDetails: (operation: Operation) => void;
  loadMoreSkeleton?: React.ReactNode;
}

export function OperationsTable({
  activeTab,
  operations,
  onShowDetails,
  loadMoreSkeleton,
}: OperationsTableProps) {
  const { t } = useTranslation();

  const sourceColumnLabel =
    activeTab === TransactionTabName.PaidAds
      ? t('pages.cabinet.invoice')
      : t('pages.cabinet.source');

  return (
    <S.Container>
      <S.Header>
        <S.HeaderCell>{t('pages.cabinet.ads')}</S.HeaderCell>
        <S.HeaderCell>{t('pages.cabinet.service')}</S.HeaderCell>
        <S.HeaderCell>{t('common.sum')}</S.HeaderCell>
        <S.HeaderCell>{sourceColumnLabel}</S.HeaderCell>
        <S.HeaderCell>{t('pages.cabinet.date')}</S.HeaderCell>
        <S.HeaderCell />
      </S.Header>

      {operations.map(operation => (
        <OperationRow
          key={operation.id}
          operation={operation}
          onShowDetails={onShowDetails}
        />
      ))}

      {loadMoreSkeleton}
    </S.Container>
  );
}
